import { render, staticRenderFns } from "./TasksViewer2.vue?vue&type=template&id=73501a8f&"
import script from "./TasksViewer2.vue?vue&type=script&lang=js&"
export * from "./TasksViewer2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports